import './style.scss';
import { Description, labelColor, labelSize } from 'views/mutual/description';

export const CompleteSendMail = () => {

  return (
    <>
      <div className="requestComplete">
        <div className="requestComplete_description">
          <Description
            labelColor={labelColor.black}
            labelSize={labelSize.extraLarge}
            label="事前質問にご回答いただきありがとうございます。"
          />         
        </div>
        <div className="requestComplete_subDescription">
          <Description
            labelColor={labelColor.gray}
            labelSize={labelSize.large}
            label="ご入力いただいたメールアドレスに、お手続き用のURLを送信しました。"
          />
          <Description
            labelColor={labelColor.gray}
            labelSize={labelSize.large}
            label="メール本文に記載されたURLより、口座開設のお手続きを続けてください。"
          />
          <Description
            labelColor={labelColor.gray}
            labelSize={labelSize.large}
            label="メールが届かない場合、迷惑メールフォルダに振り分けられていないかご確認ください。"
          />
          <Description
            labelColor={labelColor.gray}
            labelSize={labelSize.large}
            label="@fpg.jp からのメールが受信できるよう、ドメイン指定受信の設定をお願いいたします。"
          />
          <Description
            labelColor={labelColor.gray}
            labelSize={labelSize.large}
            label="※URLの有効期限は送信後、60分間です"
          />
        </div>
      </div>
    </>
  );
};